import config from 'config'
import { ApiObjectService } from './api-object.service'
import { authHeader } from '../helpers'

class TigerFactsService extends ApiObjectService {
    namespace = 'tiger-facts'
}

export const tigerFactsService = new TigerFactsService()
